import React, {useContext, useState} from 'react';
import { makeStyles } from '@material-ui/core/styles';

import {Grid, Typography} from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%'
  }
}));

export default function Experience({organization, startDate, endDate, title, children, ...props}){
  const classes = useStyles()

  return (
  <Grid item className={classes.root} xs={12}>
    <Typography variant="subtitle1" {...props}>
    <b>{organization}</b> {startDate} -- {endDate || 'Current'} <br/>
    {title}
    </Typography>

    <Typography component="div">
      {children}
    </Typography>

  </Grid>
)
}
